/**
 * Sincroniza el tab activo (`this.activeTab`) de una pantalla de detalle con
 * el query param `?tab=` de la URL, usando `this.$router` en vez de tocar
 * `window.history`/`URL` a mano.
 *
 * El componente que use este mixin debe declarar en su `data()`:
 * - `activeTab`: el tab activo, con su valor por defecto (ej. "general").
 * - `$tabsWhitelist`: array con las claves válidas de tab de esa pantalla
 *   (las mismas que usan sus `custom-navbar-item` como `id`). Claves fuera
 *   de esta lista (ej. "home", usado solo como alias visual del navbar) se
 *   ignoran tanto al leer como al escribir la URL.
 */
export default {
    data() {
        return {
            $tabQuerySyncDefaultTab: null
        };
    },
    created() {
        this.$data.$tabQuerySyncDefaultTab = this.activeTab;
        this.applyTabFromRouteQuery();
    },
    watch: {
        activeTab(value, oldValue) {
            if (value === oldValue) return;
            this.pushTabToRouteQuery(value);
        },
        "$route.query.tab"(value) {
            this.applyTabFromRouteQuery(value);
        }
    },
    methods: {
        applyTabFromRouteQuery(rawValue) {
            const whitelist = this.$data.$tabsWhitelist || [];
            const value =
                rawValue !== undefined ? rawValue : this.$route.query.tab;
            if (
                value &&
                whitelist.includes(value) &&
                this.activeTab !== value
            ) {
                this.activeTab = value;
            }
        },
        pushTabToRouteQuery(value) {
            const whitelist = this.$data.$tabsWhitelist || [];
            if (value && !whitelist.includes(value)) return;

            const query = { ...this.$route.query };
            const defaultTab = this.$data.$tabQuerySyncDefaultTab;
            if (value && value !== defaultTab) {
                query.tab = value;
            } else {
                delete query.tab;
            }
            if (query.tab === this.$route.query.tab) return;
            this.$router.replace({ query }).catch(() => {});
        }
    }
};
